export default __webpack_public_path__ + "static/lunarcrush_logo-38328ee8cecd34486f0e5d1193eb9569.png";